import React from 'react';
import { useI18n } from '../i18n/I18nProvider';
import { PRIORITY_LABEL_KEY, PRIORITY_TAG_CLASS } from '../utils/priority';
import { PROGRESS_LABEL_KEY, PROGRESS_TAG_CLASS } from '../utils/taskStatus';
import { PriorityLevel, TodoProgressKind, TodoStatusDto } from '../web-api-client';

export function ProgressBadge({ kind }: { kind: TodoProgressKind | undefined }) {
  const { t } = useI18n();
  const value = kind ?? TodoProgressKind.NotCompleted;

  return <span className={PROGRESS_TAG_CLASS[value]}>{t(PROGRESS_LABEL_KEY[value])}</span>;
}

export function PriorityBadge({ priority }: { priority: PriorityLevel | undefined }) {
  const { t, lang } = useI18n();
  const value = priority ?? PriorityLevel.None;

  if (value === PriorityLevel.None) {
    return null;
  }

  // "Ưu tiên cao" viết thường ở tiếng Việt, "High priority" viết hoa ở tiếng Anh.
  const label = t(PRIORITY_LABEL_KEY[value]);
  const level = lang === 'vi' ? label.toLowerCase() : label;

  return <span className={PRIORITY_TAG_CLASS[value]}>{t('priority.badge', { level })}</span>;
}

/**
 * Bảng tổng kết do máy chủ tính sẵn trong cột Status. Giao diện chỉ hiển thị lại, không tự cộng trừ —
 * nếu tự tính thì sẽ có ngày con số trên màn hình khác con số trong cơ sở dữ liệu.
 */
export function StatusSummary({ status }: { status: TodoStatusDto | undefined }) {
  const { t } = useI18n();
  const total = status?.total ?? 0;

  if (total === 0) {
    return <span className="text-body-secondary small">{t('todo.counts.empty')}</span>;
  }

  const parts = [t('todo.counts.done', { done: status?.completed ?? 0, total })];

  if (status?.partial) parts.push(t('todo.counts.partial', { count: status.partial }));
  if (status?.notCompleted) parts.push(t('todo.counts.notCompleted', { count: status.notCompleted }));

  return <span className="text-body-secondary small">{parts.join(' · ')}</span>;
}
